import { Box, Combobox, Flex, Switch, Text, useCombobox } from '@mantine/core'
import { useTranslations } from 'next-intl'
import { ChangeEvent } from 'react'

import Setting from '@/assets/icons/setting.svg'
import clsx from '@/utils/clsx'

import styles from '../index.module.css'
import { SettingType } from '../utils'

interface SettingButtonProps {
  settingType: SettingType | null
  onSettingChange: (type: SettingType | null) => void
  bTCPriceButtonVisible: boolean
  isShowTradingView: boolean
}

function ComboboxOption({
  value,
  onSettingChange,
  settingType,
  label,
  disabledSettingType,
}: Omit<SettingButtonProps, 'bTCPriceButtonVisible' | 'isShowTradingView'> & {
  disabledSettingType: SettingType
  label: string
  value: SettingType
}) {
  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.currentTarget.checked) {
      onSettingChange(value)
    } else {
      onSettingChange(null)
    }
  }
  const isDisabled = settingType === disabledSettingType
  return (
    <Combobox.Option value={value}>
      <Flex
        className={clsx({
          [styles.menuItem]: true,
          [styles.menuItemDisabled]: isDisabled,
        })}
      >
        <Text flex={1} variant={'subtitle'}>
          {label}
        </Text>
        <Switch
          withThumbIndicator={false}
          checked={settingType === value}
          disabled={isDisabled}
          onChange={onChange}
        />
      </Flex>
    </Combobox.Option>
  )
}

export default function SettingButton({
  settingType,
  onSettingChange,
  bTCPriceButtonVisible,
  isShowTradingView,
}: SettingButtonProps) {
  const combobox = useCombobox()
  const t = useTranslations('chart')

  return (
    <Combobox
      classNames={{
        option: styles.comboboxOption,
      }}
      width={200}
      store={combobox}
      position={'bottom-start'}
    >
      <Combobox.Target>
        <Box>
          <Setting
            className={clsx({
              [styles.settingButon]: true,
              [styles.settingButonActive]: settingType !== null,
            })}
            onClick={() => combobox.toggleDropdown()}
          />
        </Box>
      </Combobox.Target>

      <Combobox.Dropdown>
        <Combobox.Options>
          {isShowTradingView && (
            <ComboboxOption
              value={SettingType.TRADING_VIEW}
              settingType={settingType}
              onSettingChange={onSettingChange}
              disabledSettingType={SettingType.BTC_PRICE}
              label={t('tradingView')}
            />
          )}

          {bTCPriceButtonVisible && (
            <ComboboxOption
              value={SettingType.BTC_PRICE}
              settingType={settingType}
              onSettingChange={onSettingChange}
              disabledSettingType={SettingType.TRADING_VIEW}
              label={t('btcPrice')}
            />
          )}
        </Combobox.Options>
      </Combobox.Dropdown>
    </Combobox>
  )
}
